// extracted by mini-css-extract-plugin
export var icon = "social-module--icon--cF19p";
export var list = "social-module--list--Qeoof";